module.exports = {
  appName: 'LVS ProFleet',
  calendarColor: 'indigo',
  globalSupportEmail: 'profleet.uk@lombardvehiclesolutions.com',
  footerLogo: false,
  favicon: 'favicon-lvs.svg',
  themeColor: '#001e69',
}
